var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentForCalculatingTaskId({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1749041433477,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12223,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.9232 175.5136v672h672V175.5136H175.9232zM128 111.5136h768c8.8064 0 15.9744 7.168 15.9744 16.0256v768c0 8.8064-7.168 15.9744-15.9744 15.9744h-768a16.0256 16.0256 0 0 1-16.0256-15.9744v-768c0-8.8576 7.168-16.0256 16.0256-16.0256z m416 512h239.9744c4.4544 0 8.0384 3.584 8.0384 7.9872v48.0256c0 4.4032-3.584 7.9872-8.0384 7.9872h-239.9744a7.9872 7.9872 0 0 1-7.9872-7.9872v-48.0256c0-4.4032 3.584-7.9872 7.9872-7.9872z m0 103.9872h239.9744c4.4544 0 8.0384 3.584 8.0384 8.0384v47.9744c0 4.4032-3.584 7.9872-8.0384 7.9872h-239.9744a7.9872 7.9872 0 0 1-7.9872-7.9872v-47.9744c0-4.4544 3.584-8.0384 7.9872-8.0384z m-287.6928-7.8336l463.872-463.872a15.9744 15.9744 0 0 1 22.6304 0l25.4464 25.4976a16.0256 16.0256 0 0 1 0 22.6304l-463.872 463.872a16.0256 16.0256 0 0 1-22.6304 0l-25.4464-25.4976a16.0256 16.0256 0 0 1 0-22.6304zM331.7248 332.288V244.224c0-4.4032 3.584-7.9872 7.9872-7.9872h48.0256c4.4032 0 7.9872 3.584 7.9872 7.9872V332.288h88.0128c4.4032 0 7.9872 3.584 7.9872 7.9872v48.0256c0 4.4032-3.584 7.9872-7.9872 7.9872h-88.064v88.0128c0 4.4032-3.584 7.9872-7.936 7.9872h-48.0256a7.9872 7.9872 0 0 1-7.9872-7.9872V396.2368H243.712a7.9872 7.9872 0 0 1-7.9872-7.9872v-48.0256c0-4.4032 3.584-7.9872 7.9872-7.9872h88.0128z",
    fill: "currentColor",
    "p-id": 12224
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentForCalculatingTaskId);
export default __webpack_public_path__ + "static/media/content-for-calculating-task-id.57cc4f699e2f61ca36597bcb9fe221c6.svg";
export { ForwardRef as ReactComponent };